import { ChangeDetectorRef, Component } from '@angular/core';

@Component({
  selector: 'app-admin-without-footer',
  template: `

    <div class="dashboard-layout" [class.sidebar-collapsed]="isSidebarCollapsed">
      <app-menu (collapsedChange)="onSidebarCollapse($event)"></app-menu>

      <main>
        <div class="content-wrapper">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  `,
  styles: [`
    .dashboard-layout {
      display: flex;
      height: 100%;
      overflow: hidden;
    }

    app-menu {
      flex-shrink: 0;
      width: 240px;
      transition: width 0.3s ease;
    }

    .dashboard-layout.sidebar-collapsed app-menu {
      width: 70px;
    }

    .main-content {
      flex-grow: 1;
      overflow-y: auto;
      transition: all 0.3s ease;
    }
    .main-content {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      overflow-y: auto;
    }
    .content-wrapper {
      flex-grow: 1;
    }
    @media (max-width: 992px) {
      app-menu {
        width: 0;
      }
      .dashboard-layout {
        flex-direction: row-reverse;
      }
      .dashboard-layout.sidebar-collapsed app-menu {
        width: 0; // No afectará al layout en mobile
      }
    }
  `]
})
export class AdminInboxComponent {

  isSidebarCollapsed = true;

  constructor(private cdr: ChangeDetectorRef) {}

  onSidebarCollapse(collapsed: boolean) {
    this.isSidebarCollapsed = collapsed;
    this.cdr.detectChanges();
  }

}
